import $ from 'jquery';
import Vue from '../main/vue';
import router from '../main/vue-routes';

const loadSpecRequest = () => {
  if (document.querySelector('.request-a-spec')) {
    new Vue({
      el: '.request-a-spec',
      comments: true,
      data() {
        return {
          error: false,
          success: false
        };
      },
      computed: {
        query() {
          return this.$route.query.query;
        }
      },
      methods: {
        submitSpecRequest(event) {
          const formData = new FormData(event.target);
          let formattedFormData = {};

          for (let entry of formData.entries()) {
            const [key, value] = entry;
            formattedFormData[key] = value;
          }

          $.ajax({
            method: 'POST',
            url: '/spec-builder/spec-request',
            data: `form=${JSON.stringify(formattedFormData)}`
          })
            .done(() => {
              this.error = false;
              this.success = true;
            })
            .catch(() => {
              this.error = true;
              this.success = false;
            });
        }
      },
      router
    });
  }
};

export default loadSpecRequest;
